import { useTranslation } from 'react-i18next';
import type { AgentCopyKey } from '@worki/shared';

export function useAgentCopy() {
    const { t } = useTranslation();
    return (key: AgentCopyKey) => t(`agentUi.${key}`);
}
export function useAgentOperation() {
    const { t } = useTranslation();
    return (name: string, fallback: string) => t(`agentOperations.${name}`, { defaultValue: fallback });
}
export function useAgentField() {
    const { t } = useTranslation();
    return (name: string) => t(`agentFields.${name}`, { defaultValue: name.replace(/([A-Z])/g, ' $1') });
}
